<template>
  <v-app class="grey lighten-4" style="max-height: 100vh">
    <NavBar v-if="$router.currentRoute.name !== 'home'" />

    <v-main
      v-bind:class="{
        sientificLight: userSettings.theme == 'Scientific' && !this.darkmode,
        sientificDark: userSettings.theme == 'Scientific' && this.darkmode,
        backg: !this.darkmode && userSettings.theme != 'Scientific',
        backgdark: this.darkmode && userSettings.theme != 'Scientific',
      }"
      style="padding: 0"
    >
      <router-view></router-view>
    </v-main>

    <v-snackbar
      v-model="refresh"
      v-if="message != ''"
      bottom
      right
      :timeout="3000"
      >{{ message }}</v-snackbar
    >

    <v-footer app v-if="$router.currentRoute.name === 'dashboardChooser'">
      <span>&copy; 2021 - Powered By IoT Application And Hardware AB</span>
    </v-footer>
  </v-app>
</template>

<script>
import NavBar from "@/components/NavBar";
import { mapActions, mapState } from "vuex";

export default {
  name: "App",
  components: {
    NavBar,
  },
  data() {
    return {
      refresh: false,
      landing: false,
    };
  },

  updated() {
    if (this.$router.currentRoute.name == "home") {
      this.landing = true;
    }
  },
  created() {
    this.$vuetify.theme.dark = this.darkmode;
    this.clearAlert();
  },
  computed: {
    ...mapState("alert", ["active", "message"]),
    ...mapState("configuration", ["darkmode", "userSettings"]),
  },
  methods: {
    ...mapActions({ clearAlert: "alert/clear" }),
  },

  watch: {
    message(val) {
      if (val) {
        this.refresh = true;
      } else {
        this.refresh = false;
      }
    },

    refresh(value) {
      if (value === false) this.clearAlert();
    },
  },
};
</script>

<style>
.backg {
  /* background: rgb(235, 235, 235); */
  background-image: url("/bg.jpg");
  background-size: cover;
}
.backgdark {
  background-image: url("/bgdark.jpg");
  background-size: cover;
}

.sientificLight {
  background-color: #e9e9e9;
}

.sientificDark {
  background-color: #121212;
}
</style>
